export default "__VITE_ASSET__BmLnbRU$__"